import { Redirect } from 'expo-router';
import Head from 'expo-router/head';

import { RewardsHistoryScreen } from '@fhs/loyalty';
import useAuth from '@fhs-legacy/frontend/src/hooks/auth/use-auth';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function HistoryPage() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Redirect href={routes.signIn} withAnchor={false} />;
  }

  return (
    <>
      <Head>
        <title>Rewards History - Firehouse Subs</title>
      </Head>
      <RewardsHistoryScreen />
    </>
  );
}
